import { NbSamlPassOAuthProvider } from '@hm_app/hm-auth/netfarmOAuthService/saml/saml-pass-oauth.provider';
import { NbEmailPassOAuthProvider_CONFIG, NbSamlPassOAuthProvider_CONFIG } from '@src/environments/configs';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { of as observableOf } from 'rxjs';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { DataModule } from './data/data.module';
import { AnalyticsService } from './utils/analytics.service';
import { HmRoleProvider } from '@hm_app/hm-auth/netfarmOAuthService/role-provider';
import { LayoutService } from './utils/layout.service';


export function getRole() {
    return observableOf('guest'); // here you could provide any role based on any auth flow
}

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        NbAuthModule,
    ],
    declarations: [],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
          ngModule: CoreModule,
            providers: [
                ...DataModule.forRoot().providers,
                ...NbAuthModule.forRoot({
                    forms: {
                        login: {
                            redirectDelay: 500, // delay before redirect after a successful login, while success message is shown to the user
                            provider: 'email',  // provider id key. If you have multiple providers, or what to use your own you need to tell a component to use it here
                            rememberMe: false,   // whether to show or not the `rememberMe` checkbox
                            showMessages: {     // show/not show success/error messages
                                success: true,
                                error: true,
                            },
                        },
                        register: {
                            redirectDelay: 500,
                            provider: 'email',
                            showMessages: {
                                success: true,
                                error: true,
                            },
                            terms: true,
                        },
                        requestPassword: {
                            redirectDelay: 500,
                            provider: 'email',
                            showMessages: {
                                success: true,
                                error: true,
                            },
                        },
                        resetPassword: {
                            redirectDelay: 500,
                            provider: 'email',
                            showMessages: {
                                success: true,
                                error: true,
                            },
                        },
                        logout: {
                            redirectDelay: 500,
                            provider: 'email',

                        },
                        validation: {  // fields validation rules. The validations are shared between all forms.
                            password: {
                                required: true,
                                minLength: 4,
                                maxLength: 50,
                            },
                            email: {
                                required: true,
                            },
                            fullName: {
                                required: false,
                                minLength: 4,
                                maxLength: 50,
                            },
                        },
                    },

                    strategies: [
                        NbPasswordAuthStrategy.setup(NbEmailPassOAuthProvider_CONFIG),
                        NbSamlPassOAuthProvider.setup(NbSamlPassOAuthProvider_CONFIG),
                    ],

                }).providers,
                NbSecurityModule.forRoot({
                    accessControl: {
                        guest: {
                            view: '*',
                        },
                        administrator: {
                            parent: 'guest',
                            create: '*',
                            edit: '*',
                            remove: '*',
                        },
                    },
                }).providers,
                { provide: NbRoleProvider, useClass: HmRoleProvider },
                AnalyticsService,
                LayoutService,
            ],
        };
    }
}
